module.exports = __webpack_public_path__ + "./Carol_pbw_1c51dbaf4399c7ccb6dffedb6aa66b9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Carol_pbw.png
// module id = 589
// module chunks = 0